<template>
  <router-link :to="childRoute"
               :class="headerItemStyles"
               class="header-children-item"
               active-class="active"
               v-if="child">
    <child-avatar class="avatar"
                  :child="child"
                  :icon="getStatusIcon"
                  icon-color="#fff"
                  icon-background-color="#f35f5f"
                  out-of-sync-position="right"
                  show-out-of-sync
                  @click="openChildProfile" />
    <div v-if="displayName"
         class="name one-liner"
         :data-title="child.name">
      {{ child.name }}
    </div>
  </router-link>
</template>

<script>
  import ChildAvatar from '@/components/Child/ChildAvatar.vue'
  import analytics from '@/services/analytics.js'

  export default {
    props: {
      child: {
        required: true,
        type: Object
      }
    },

    components: {
      ChildAvatar
    },

    computed: {
      childRoute() {
        return {
          name: 'children.single',
          params: {
            id: this.child.id
          }
        }
      },

      getStatusIcon() {
        if (this.child.status.some_device_is_out_of_sync) {
          return 'IconExclamationSign'
        } else {
          return ''
        }
      },

      displayName() {
        return this.$mq !== 'mobile'
      },

      headerItemStyles() {
        return {
          'header-children-item-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      openChildProfile() {
        analytics.sendEvent('Pk_Child')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header-children-item {
    display: flex;
    align-items: center;
    max-width: 170px;
    height: 100%;
    text-decoration: none;

    .avatar {
      flex-shrink: 0;
      margin-right: 8px;
    }

    .name {
      padding: 2px 8px;
      font-size: 16px;
      font-weight: 300;
      line-height: 1;
      color: #fff;
      border-radius: 4px;
      user-select: none;
      transition: all .1s ease-out;

      &::after {
        display: block;
        content: attr(data-title);
        font-weight: bold;
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }
    }

    &:hover,
    &.active {
      .name {
        font-weight: bold;
        color: map-get($colors, primary);
        background-color: #fff;
      }
    }
  }

  .header-children-item-mobile {
    .avatar /deep/ {
      opacity: .5;

      .pale {
        opacity: 1;
      }
    }

    &:hover,
    &.active {
      .avatar {
        opacity: 1;
      }
    }
  }
</style>
